module.exports = __webpack_public_path__ + "fa6912a41c2be478d193a4e1bc41b340.png";